import apiService from 'v2/services/api';

import type { ApiService } from 'v2/services/api';

export class Transfer {
  constructor(private apiServices: ApiService) {}

  public getAvailablenarturalPerson = () => this.apiServices.get('financial-statement/balance/available-for-natural-person');
}

export const transferService = new Transfer(apiService);
